/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteAccount.defs.js'
export * as $defs from './deleteAccount.defs.js'
